import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PushSettings } from "@/components/PushSettings";
import { Bell, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function NotificationBell() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);

  const load = async () => {
    try {
      const [n, c] = await Promise.all([
        api.get("/notifications"),
        api.get("/notifications/unread-count"),
      ]);
      setItems(n.data);
      setCount(c.data.count);
    } catch (e) {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <DropdownMenu open={open} onOpenChange={(o) => { setOpen(o); if (o) load(); }}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notification-bell">
          <Bell className="w-5 h-5" />
          {count > 0 && (
            <span
              data-testid="notification-count"
              className="absolute -top-0.5 -right-0.5 bg-rose-500 text-white text-[10px] font-bold rounded-full min-w-4 h-4 px-1 flex items-center justify-center"
            >
              {count}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <span className="font-semibold text-sm">Notificaties</span>
          <Button variant="ghost" size="sm" className="h-7 text-xs" onClick={markAll} data-testid="notification-mark-all">
            <Check className="w-3.5 h-3.5 mr-1" /> Alles gelezen
          </Button>
        </div>
        <PushSettings />
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 && (
            <p className="text-sm text-muted-foreground px-4 py-6 text-center">Geen notificaties</p>
          )}
          {items.map((n) => (
            <button
              type="button"
              key={n.id}
              data-testid={`notification-open-${n.id}`}
              disabled={!n.link?.startsWith("/") || n.link.startsWith("//")}
              onClick={() => { setOpen(false); navigate(n.link); }}
              className={`w-full text-left px-4 py-3 border-b last:border-0 transition-colors hover:bg-muted disabled:cursor-default ${n.read ? "opacity-60" : "bg-accent/40"}`}
            >
              <p className="text-sm font-medium">{n.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{n.message}</p>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
